import { render, staticRenderFns } from "./Datamanagement.vue?vue&type=template&id=5615d362&scoped=true&"
import script from "./Datamanagement.vue?vue&type=script&lang=js&"
export * from "./Datamanagement.vue?vue&type=script&lang=js&"
import style0 from "./Datamanagement.vue?vue&type=style&index=0&id=5615d362&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5615d362",
  null
  
)

export default component.exports